<template>
<el-drawer :title="drawer.title" :visible.sync="drawer.visible" direction="rtl" :before-close="closeDrawer">
  <div class="drawer-form">
    <el-form :model="hotelForm" status-icon ref="hotelForm" label-width="100px" label-position="left" :rules="rules">
      <el-form-item label="酒店名称" prop="hotel_id">
        <el-select v-model="hotelForm.hotel_id" filterable placeholder="请选择" @change="chooseHotel">
          <el-option v-for="item in hotelList" :key="item.id" :label="item.title" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('hotelForm')">提交</el-button>
        <el-button @click="closeDrawer">取消</el-button>
      </el-form-item>

      <div class="bound-box">
        <div class="bound-title">已绑定酒店列表</div>
        <el-table :data="userHotelList" style="width: 100%">
          <el-table-column label="酒店名称" width="200">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.hotel.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="unbindHotel(scope.row)">解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
  </div>
</el-drawer>
</template>

<script>
export default {
  name: 'bindHotel',
  props: {
    hotelList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      drawer: {
        title: '绑定酒店',
        visible: false
      },

      // 接口需要的参数
      apiParams: {
        hotel_id: '',
        user_id: 0
      },

      hotelForm: {
        hotel_id: '',
        user_id: 0,
        // 所有酒店
        allHotel: 0
      },
      rules: {
        hotel_id: [{
          required: true,
          message: '请选择要绑定的酒店',
          trigger: 'change'
        }],
        allHotel: [{
          required: true,
          message: '请选择绑定酒店类型',
          trigger: 'change'
        }]
      },
      // 已绑定酒店列表
      userHotelList: []
    };
  },
  created() {},
  methods: {
    // 显示抽屉
    showDrawer(data) {
      this.drawer.visible = true;
      this.hotelForm.user_id = data.id;
      this.apiParams.user_id = data.id;
      this.getUserHotel();
    },

    // 关闭时清空内容
    closeDrawer() {
      this.apiParams = {
        hotel_id: '',
        user_id: 0
      };
      this.hotelForm = {
        hotel_id: '',
        user_id: 0,
        allHotel: 0
      };
      this.allHotel = null;
      this.drawer.visible = false;
      this.$refs['hotelForm'].resetFields();
    },

    // 获取用户已绑定酒店列表
    getUserHotel() {
      let url = '/api/ucenter.user/hotels';
      let that = this;
      let params = {
        user_id: that.apiParams.user_id
      };
      this.$post(url, params).then(function (res) {
        if (res.code == 200) {
          that.userHotelList = res.data.list;
        } else {
          that.$message.error(res.msg);
        }
      });
    },

    // 选择酒店
    chooseHotel(e) {
      this.apiParams.hotel_id = e;
    },

    // 解除绑定
    unbindHotel(data) {
      let that = this;
      let params = {
        user_id: this.apiParams.user_id,
        hotel_id: data.store_id
      };
      that.$confirm('确认解绑?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          let url = '/api/ucenter.user/unbindHotel';
          this.$post(url, params).then(function (res) {
            if (res.code == 200) {
              that.$message.success(res.msg);
              that.getUserHotel();
              that.$emit('getTableData');
            } else {
              that.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消解绑'
          });
        });
    },

    // 提交
    submitForm(formName) {
      let that = this
      let params = that.apiParams;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let url = '/api/ucenter.user/bindHotel';
          this.$post(url, params).then(function (res) {
            if (res.code == 200) {
              that.$emit('getTableData');
              that.getUserHotel()
              that.$message.success(res.msg);
            } else {
              that.$message.error(res.msg);
            }
          });
        } else {
          that.$message('请填写完整并检查您的填写信息');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.bound-title {
  font-weight: bold;
  font-size: 14px;
  color: #606266;
}

@import url('@/assets/css/drawer.less');
</style>
